import React, { Component, PropTypes } from 'react';
import PageModule from '../PageModule';
import css from '../css';
import { translate as _l } from 'oxygen-i18n';
import { Text, TextField, TextArea, Button } from 'cio';
import PageLayoutActions from 'actions/PageLayout';
import PageModuleActions from 'actions/PageModule';
import Media from 'Util/Media';

addTranslations({
  ['en-US']: {
    'Write a caption...': 'Write a caption...',
    'Paste embed code...': 'Paste embed code...',
    'Include content from a number of popular services like YouTube, Slideshare, Typeform and more.':
      'Include content from a number of popular services like YouTube, Slideshare, Typeform and more.',
    'Embed external content': 'Embed external content',
    Embed: 'Embed'
  },
  ['sv-SE']: {
    'Write a caption...': 'Bildtext',
    'Paste embed code...': 'Klistra in embed länken här',
    'Include content from a number of popular services like YouTube, Slideshare, Typeform and more.':
      'Klistra in material från bl.a YouTube, Smideshare, Typeform och många fler ',
    'Embed external content': 'Bädda in externt material',
    Embed: 'Bädda in'
  }
});

class EmbedModuleEditor extends Component {
  static propTypes = {
    children: PropTypes.node,
    sources: PropTypes.array,
    id: PropTypes.number
  };

  constructor() {
    super(...arguments);
    const source = this.props.sources[0] || {};
    if (source.provider > 0 && source.provider < 7) {
      this.state = {
        url: Media.getUrlFromProvider({
          provider: source.provider,
          id: source.data
        })
      };
    } else {
      this.state = {
        url: source.data
      };
    }
  }

  changeCaption = caption => {
    const { sources, id } = this.props;
    const [source] = sources;
    PageLayoutActions.changePageModuleData({
      id,
      data: {
        params: {
          caption: [caption]
        },
        sources: [
          {
            ...source,
            caption
          }
        ]
      }
    });
  };

  changeEmbed = embed => {
    const { sources, id } = this.props;
    const [source] = sources;
    const recognized = Media.getProviderFromUrl(embed);
    this.setState({ url: embed });
    PageLayoutActions.changePageModuleData({
      id,
      data: {
        sources: [
          {
            ...source,
            data: recognized.id,
            provider: recognized.provider
          }
        ]
      }
    });
  };

  detailMode = () => {
    const { id } = this.props;
    PageModuleActions.changePageModuleMode(id, 'detail');
    PageLayoutActions.savePageModule(id);
  };

  render() {
    const { sources, ...other } = this.props;
    const source = sources[0] || {};
    const { url } = this.state;
    return (
      <PageModule i {...other}>
        <div className={css.panel}>
          <h2>{_l`Embed external content`}</h2>
          <Text
            secondary
          >{_l`Include content from a number of popular services like YouTube, Slideshare, Typeform and more.`}</Text>
        </div>
        <div className={css.container}>
          <div className={css.pad}>
            <TextArea
              fullWidth
              placeholder={_l`Paste embed code...`}
              value={url}
              onChange={this.changeEmbed}
            />
          </div>
          <div className={css.pad}>
            <TextField
              placeholder={_l`Write a caption...`}
              value={source.caption}
              onChange={this.changeCaption}
            />
          </div>
          <div className={css.pad}>
            <Button label={_l`Embed`} onTouchTap={this.detailMode} />
          </div>
        </div>
      </PageModule>
    );
  }
}

export default EmbedModuleEditor;



// WEBPACK FOOTER //
// ./src/js/module/Edit/EmbedModuleEditor.js